module.exports = __webpack_public_path__ + "static/media/company.a2411ed6.svg";